import qs from 'query-string';
import omit from 'lodash.omit';

/**
 * Gets the invitation details from the search query.
 *
 * @param {Object} location React router location object.
 */
export const getInvitiationDetailsFromSearchQuery = location => {
  const { phoneNumber, token, shareId, email } = qs.parse(
    // From Luis: This looks fairly hacky, and perhaps it is, but if location
    // if previously parsed from some other place (i.e, EmailAuthLinkResolver), the plus
    // signs become + (rather than 2B) which are later on parsed here as spaces and not plus signs.
    // This breaks invite API for emails with + signs...
    (location?.search ?? '').replace('+', '%2B'),
  );

  return shareId && token
    ? {
        email,
        phoneNumber,
        shareId,
        token,
      }
    : undefined;
};

/**
 * Returns the finalized invitationDetails object based on both the local
 * stored contributor invitation details and the location search query.
 *
 * @param {Object} location React router location object.
 * @param {Object} contributorInvitationDetails Local stored contributor invitation details. Stored by the ContributorsRedirect component.
 *
 * @see ContributorsRedirect
 *
 * @returns {Object} The finalized invitation details object.
 */
export const getInvitiationDetails = (
  location,
  contributorInvitationDetails,
) => ({
  ...(getInvitiationDetailsFromSearchQuery(location) ?? {}),
  ...contributorInvitationDetails,
});

export const getContributorInvitationDetailsSearchQuery = contributorInvitationDetails => {
  return qs.stringify(
    { ...omit(contributorInvitationDetails, ['__typename']) },
    { skipNull: true, skipEmptyString: true, sort: false, encode: false },
  );
};
